import { Link } from "react-router-dom";

export default function ComparisonSection() {
  return (
    <section className="relative w-full py-16 md:py-24 bg-foreground-900">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <span className="inline-block px-3 py-1 bg-accent-500/20 text-accent-300 text-xs font-medium rounded-md font-label">
            / ACBuy Spreadsheet
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-4 max-w-2xl leading-tight">
            ACBuySpreadsheet vs Competitors
          </h2>
          <p className="mt-4 text-foreground-300 text-sm md:text-base max-w-xl leading-relaxed">
            See how the acbuy spreadsheet system compares against popular alternatives. Our transparent comparison helps you make an informed decision about which tracking solution best fits your workflow needs.
          </p>
        </div>

        <div className="overflow-x-auto mb-12">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-foreground-700/40">
                <th className="py-3 px-4 text-xs font-semibold text-foreground-300 uppercase tracking-wider whitespace-nowrap">Feature</th>
                <th className="py-3 px-4 text-xs font-semibold text-primary-400 uppercase tracking-wider whitespace-nowrap">ACBuySpreadsheet</th>
                <th className="py-3 px-4 text-xs font-semibold text-foreground-400 uppercase tracking-wider whitespace-nowrap">Google Sheets</th>
                <th className="py-3 px-4 text-xs font-semibold text-foreground-400 uppercase tracking-wider whitespace-nowrap">Notion</th>
              </tr>
            </thead>
            <tbody>
              {[
                { feature: "Automation", acbuy: "High", sheets: "Medium", notion: "Low" },
                { feature: "SEO Structure", acbuy: "High", sheets: "Low", notion: "Medium" },
                { feature: "Workflow Speed", acbuy: "Fast", sheets: "Medium", notion: "Slow" },
                { feature: "Data Organization", acbuy: "Excellent", sheets: "Good", notion: "Fair" },
                { feature: "Scalability", acbuy: "Excellent", sheets: "Good", notion: "Medium" },
                { feature: "Learning Curve", acbuy: "Easy", sheets: "Medium", notion: "Medium" },
              ].map((row, i) => (
                <tr key={i} className="border-b border-foreground-700/20 hover:bg-foreground-800/30 transition-colors">
                  <td className="py-3 px-4 text-sm text-foreground-200 font-medium whitespace-nowrap">{row.feature}</td>
                  <td className="py-3 px-4 text-sm text-primary-400 font-semibold whitespace-nowrap">{row.acbuy}</td>
                  <td className="py-3 px-4 text-sm text-foreground-400 whitespace-nowrap">{row.sheets}</td>
                  <td className="py-3 px-4 text-sm text-foreground-400 whitespace-nowrap">{row.notion}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
          <div className="w-full lg:w-[45%]">
            <div className="rounded-2xl overflow-hidden bg-background-100 aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20setup%20with%20laptop%20displaying%20organized%20data%20dashboard%20alongside%20a%20tablet%20showing%20spreadsheet%20interface%2C%20small%20ceramic%20vase%20with%20dried%20flowers%2C%20warm%20natural%20lighting%20from%20window%20casting%20soft%20shadows%2C%20calm%20productive%20atmosphere%2C%20minimalist%20workspace%20photography%20with%20warm%20cream%20and%20taupe%20tones%2C%20editorial%20home%20office%20aesthetic%2C%20sophisticated%20professional%20environment&width=900&height=675&seq=comparison-section-v3&orientation=landscape"
                alt="ACBuySpreadsheet productivity dashboard"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1">
            <div className="flex items-baseline gap-2">
              <span className="font-heading text-7xl md:text-8xl font-black text-white">98%</span>
            </div>
            <p className="mt-2 text-foreground-300 text-sm md:text-base leading-relaxed">
              of users report improved workflow efficiency within the first week of switching to the acbuy spreadsheet system. Our privacy-first architecture ensures your data stays secure — no selling, no tracking abuse, and no hidden data collection.
            </p>
            <div className="mt-6 space-y-3">
              {[
                "No data selling — your information stays yours",
                "Privacy-first structure with transparent methodology",
                "Secure spreadsheet tracking with verified integrity",
                "Regular security audits and best practice compliance",
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-500/20 mt-0.5 flex-shrink-0">
                    <i className="ri-check-line text-primary-400 text-xs"></i>
                  </span>
                  <span className="text-sm text-foreground-200">{item}</span>
                </div>
              ))}
            </div>
            <Link
              to="/what-is-acbuyspreadsheet"
              className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-white text-foreground-950 rounded-full text-sm font-semibold hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap"
            >
              View Full Analysis
              <i className="ri-arrow-right-line text-sm"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}